import React from 'react';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import ServiceContents from '../Components/ServiceContents';
import SubmitArea from '../Components/SubmitArea';

const Service = () => {
    return (
        <div>
            <Header/>
            <ServiceContents/>
            <SubmitArea/>
            <Footer/>
        </div>
    );
};

export default Service;